module.exports = __webpack_public_path__ + "img/completedacourse_ILT_completed.f89bf85a.svg";